:host {
  display: block;
}
.qumra-option-input-container{
  display: flex;
  gap: 8px;
}
.qumra-option-input-container >div {
   display: flex;
   align-items: center;
   justify-content: center;
   cursor: pointer;
   border-radius: var(--mainRadius);
   padding: 4px 8px;
   border: 1px solid var(--mainColor);
   color: var(--mainColor);
}